<template>
    <div
        class="intro-bg"
        :style="{
  'backgroundImage': 'url('+bgSrc+')'
}"
        @click="toDesc(link)"
    >
        <div class="name">
            {{title}}
        </div>
        <div class="desc">
            {{desc}}
        </div>
        <a
            class="desc-a-link"
            @click="toDesc(link)"
        >
        
            <button class="btn-link btn-link-arrow">查看更多</button>
        </a>

        <!-- <router-link
            to="/more/?menu=9&label=1"
            target="_blank"
        >
        </router-link> -->
    </div>
</template>

<script>
export default {
    props: ["title", "bgSrc", "desc", "link"],
    methods: {
        toDesc(link) {
            console.log("跳转详情页", link);
            this.$router.push({
                path: "/more/",
                query: { menu: link, label: "1" },
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.intro-bg {
    padding: 24px;
    margin-bottom: 16px;
    background-repeat: no-repeat;
    background-size: cover;
    cursor: pointer;

    &:hover {
        background-image: url("https://download.dameng.com/eco/vip/assets/hover.svg") !important;
    }

    .name {
        font-size: 20px;
        font-weight: 600;
        color: rgba(0, 0, 0, 0.85);
        line-height: 28px;
        margin-bottom: 12px;
    }

    .desc {
        font-size: 12px;
        font-weight: 400;
        color: rgba(0, 0, 0, 0.45);
        line-height: 20px;
        width: 192px;
        height: 72px;
        margin-bottom: 8px;
    }

    .desc-a-link {
        color: #4771f8;
    }

    &:hover .icon-arrow {
        transform: translate3d(6px, 0, 0);
        transition: all 0.2s;
    }
    .icon-arrow {
        transition: 0.2s ease-in-out transform;
    }
}
</style>
